module.exports = require("@embedpdf/plugin-viewport/react");